import React from 'react';
import { Box } from 'grommet';
import OutTracker from './OutTracker';
import InningTracker from './InningTracker';
import BaseTracker from './BaseTracker';

interface GameTrackerProps {
  runners: number[];
  outs: number;
  inning: { inning: number; half: string };
}

const GameTracker: React.FC<GameTrackerProps> = ({ runners, outs, inning }) => {
  return (
    <Box data-testid="game-tracker" className="game-tracker" margin="auto">
      <BaseTracker runners={runners} />
      <OutTracker outs={outs} />
      <InningTracker {...inning} />
    </Box>
  );
};

export default GameTracker;
